import { render } from "./ObjectListConnections.vue?vue&type=template&id=8e0b6220&scoped=true"
import script from "./ObjectListConnections.vue?vue&type=script&lang=js"
export * from "./ObjectListConnections.vue?vue&type=script&lang=js"

import "./ObjectListConnections.vue?vue&type=style&index=0&id=8e0b6220&lang=scss"
import "./ObjectListConnections.vue?vue&type=style&index=1&id=8e0b6220&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0b6220"]])

export default __exports__